import { FacilitiesApiService } from 'src/app/@core/api/facilities-api.service';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of, Subscription } from 'rxjs';
import { ParkbaseStorageService } from 'src/app/@shared/services/parkbaseStorage.service';
import { StatusPageService } from '../../services/status-page.service';
import { TerminalSummaryPerTerminalType } from 'src/app/@core/domain/interfaces/terminal.interface';
import {
  AfterContentChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Facility } from '../../../../@core/domain/interfaces/facility.interface';

@Component({
  selector: 'app-terminals',
  templateUrl: './terminals.component.html',
  styleUrls: ['./terminals.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TerminalsComponent implements OnInit, AfterContentChecked, OnDestroy {
  @Input() facility!: Facility;

  facilityTerminalsSummary$: Observable<TerminalSummaryPerTerminalType[]> = of([]);
  loading = true;
  obs!: Subscription;

  @ViewChild('acc') accordion!: NgbAccordion;

  opened = false;
  icon = 'expand';
  activePanel = false;
  firstAutomaticToggle = false;

  constructor(
    private parkbaseStorageService: ParkbaseStorageService,
    private facilitiesApiService: FacilitiesApiService,
    private cdr: ChangeDetectorRef,
    private statusPageService: StatusPageService
  ) {}

  ngOnInit(): void {
    if (this.facility.id) {
      this.facilityTerminalsSummary$ = this.facilitiesApiService.facilityTerminalsSummary;
      this.facilitiesApiService.loadFacilityTerminalsSummary(this.facility.id);
      this.obs = this.statusPageService.refreshTerminalSummary.subscribe((status) => {
        if (status) {
          this.facilitiesApiService.loadFacilityTerminalsSummary(this.facility.id);
        }
      });
    }
  }

  ngAfterContentChecked() {
    if (!this.firstAutomaticToggle && this.accordion && this.accordion.activeIds.length === 0) {
      this.accordion.activeIds = ['static-0', 'static-1']; // bootstrap id
      this.accordion.expand('static-0-header');
      this.firstAutomaticToggle = true;
      this.icon = 'collapse';
      this.opened = true;
    }
  }

  open(index: number): void {
    this.activePanel = true;
  }

  trackByFn(index: number): number {
    return index;
  }

  toggleTerminals() {
    if (this.opened) {
      this.accordion.collapseAll();
      this.icon = 'expand';
      this.opened = false;
    } else {
      this.accordion.expandAll();
      this.icon = 'collapse';
      this.opened = true;
    }
  }

  ngOnDestroy(): void {
    this.obs.unsubscribe();
  }
}
